import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { actualizarCurso, cambiarEstadoCurso, obtenerCursoPorId } from '../services/cursosService'
import CursoForm from '../components/cursos/CursoForm'
import EstadoCursoBadge from '../components/cursos/EstadoCursoBadge'

export default function EditarCursoPage() {
  const { id } = useParams()
  const { organizacion } = useAuth()
  const navigate = useNavigate()
  const [curso, setCurso] = useState(null)
  const [loading, setLoading] = useState(true)
  const [changing, setChanging] = useState(false)
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')

  useEffect(() => {
    let active = true
    obtenerCursoPorId(organizacion.id, id)
      .then((result) => { if (active) setCurso(result) })
      .catch((loadError) => { if (active) setError(loadError.message) })
      .finally(() => { if (active) setLoading(false) })
    return () => { active = false }
  }, [organizacion.id, id])

  async function handleSubmit(values) {
    if (curso.activo && !values.activo && !window.confirm('¿Deseas inactivar este curso?')) return false
    await actualizarCurso(organizacion.id, id, values)
    navigate('/cursos', { replace: true, state: { message: 'Curso actualizado correctamente.' } })
  }

  async function changeStatus() {
    const nextStatus = !curso.activo
    if (!nextStatus && !window.confirm('¿Deseas inactivar este curso?')) return
    setChanging(true)
    setError('')
    setMessage('')
    try {
      const updated = await cambiarEstadoCurso(organizacion.id, id, nextStatus)
      setCurso(updated)
      setMessage(nextStatus ? 'Curso reactivado correctamente.' : 'Curso inactivado correctamente.')
    } catch (changeError) {
      setError(changeError.message)
    } finally {
      setChanging(false)
    }
  }

  if (loading) return <div className="py-16 text-center text-sm text-text-secondary">Cargando curso…</div>
  if (!curso) return <div className="rounded-2xl border border-danger/25 bg-danger/5 p-6 text-danger" role="alert">{error || 'Curso no encontrado.'}</div>

  return (
    <div className="mx-auto max-w-4xl space-y-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div><p className="text-sm font-semibold text-primary">Cursos</p><h2 className="mt-1 text-3xl font-bold tracking-tight">Editar curso</h2><div className="mt-3"><EstadoCursoBadge activo={curso.activo} /></div></div>
        <button type="button" onClick={changeStatus} disabled={changing} className={`rounded-xl px-4 py-2.5 font-semibold text-white transition disabled:opacity-60 ${curso.activo ? 'bg-danger hover:brightness-95' : 'bg-success-text hover:brightness-95'}`}>{changing ? 'Actualizando…' : curso.activo ? 'Inactivar curso' : 'Reactivar curso'}</button>
      </div>
      {message && <div className="rounded-xl border border-success/30 bg-success/10 p-4 text-sm font-medium text-success-text" role="status">{message}</div>}
      {error && <div className="rounded-xl border border-danger/25 bg-danger/5 p-4 text-sm text-danger" role="alert">{error}</div>}
      <CursoForm key={`${curso.id}-${curso.activo}`} initialValues={curso} onSubmit={handleSubmit} onCancel={() => navigate('/cursos')} submitLabel="Guardar cambios" />
    </div>
  )
}
